/**
 * BlockOrderModal — popup para bloquear encomenda com motivo.
 * JA: tabela extensível de motivos.
 */
import { useEffect, useState } from 'react';
import api from '../../../services/api.js';

const BlockOrderModal = ({ orderId, onClose, onBlocked }) => {
  const [reasons, setReasons] = useState([]);
  const [reasonId, setReasonId] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get('/block-reasons').then((r) => {
      setReasons(r.data);
      if (r.data.length) setReasonId(r.data[0].id);
    }).catch((e) => setErr(e.message));
  }, []);

  const submit = async () => {
    if (!reasonId) return;
    setLoading(true); setErr(null);
    try {
      const r = await api.post(`/orders/${orderId}/block`, {
        block_reason_id: reasonId,
        block_description: description || null,
      });
      onBlocked?.(r.data);
      onClose();
    } catch (e) {
      setErr(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gencrm_modal_overlay" onClick={onClose}>
      <div className="gencrm_modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="gencrm_modal__header">
          <h3>Bloquear Encomenda</h3>
          <button className="gencrm_modal__close" onClick={onClose}>×</button>
        </div>
        <div className="gencrm_modal__body">
          {err && <div className="gencrm_ws_error">{err}</div>}

          <label className="gencrm_field_label">Motivo</label>
          <select
            className="gencrm_field_input"
            value={reasonId}
            onChange={(e) => setReasonId(e.target.value)}
          >
            {reasons.map((r) => (
              <option key={r.id} value={r.id}>{r.name}</option>
            ))}
          </select>

          <label className="gencrm_field_label">Descrição (opcional)</label>
          <textarea
            className="gencrm_field_input"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Dethe BLO…"
          />

          <div className="gencrm_modal__footer">
            <button className="gencrm_btn" onClick={onClose} disabled={loading}>Cancelar</button>
            <button className="gencrm_btn gencrm_btn--danger" onClick={submit} disabled={loading || !reasonId}>
              {loading ? 'A bloquear…' : 'Confirmar bloqueio'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockOrderModal;
